import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router";
import { connect } from "react-redux";

import LoggedInContainer from "web_modules/shared/LoggedInContainer";
import { finishLoading as finishLoadingAction } from "web_modules/underwriter_dashboard/actions";

import PipelinePage from "./PipelinePage";
import { getSessionToken } from "../shared/session";
import { getHeaderLinksForUser, navPaths } from "../shared/nav_paths";

const styles = require("./styles.module.scss");

interface Props {
  finishLoading: () => (dispatch: any) => any;
}

const ReportingDashboard: React.FC<Props> = ({ finishLoading }) => {
  useEffect(() => {
    finishLoading();
  }, [finishLoading]);

  return (
    <div className={styles.container}>
      <LoggedInContainer
        titleLink={{
          name: "Reporting",
          to: navPaths.root,
        }}
        headerLinks={getHeaderLinksForUser(getSessionToken())}
      >
        <Switch>
          <Route exact path="/reporting/pipeline" component={PipelinePage} />
          <Route exact path="/reporting/pipeline/:viewId/:viewTitle" component={PipelinePage} />
          <Route path="/reporting">
            <Redirect to="/reporting/pipeline" />
          </Route>
        </Switch>
      </LoggedInContainer>
    </div>
  );
};

export default connect(null, { finishLoading: finishLoadingAction })(ReportingDashboard);
